module.exports = __webpack_public_path__ + "img/logo-numbersquad.64792285.svg";